import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ size = 'default', showText = false, className = '', clickable = true }) => {
  const navigate = useNavigate();
  
  // Size variants for different contexts
  const sizes = {
    small: { height: 40, width: 68 },   // For compact headers
    default: { height: 50, width: 85 }, // For main navigation
    large: { height: 100, width: 170 }, // For full size display
  };

  const { height, width } = sizes[size] || sizes.default;

  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };

  return (
    <div 
      className={`flex items-center space-x-3 ${className} ${clickable ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={(e) => {
        if (clickable && (e.key === 'Enter' || e.key === ' ')) {
          handleClick();
        }
      }}
    >
      <img
        src="https://customer-assets.emergentagent.com/job_festival-admin-3/artifacts/vk0my9ha_RUB_logo_Siden_1989_CMYK_170x100.png"
        alt="Rock Under Broen - Gå til forsiden"
        style={{ height: `${height}px`, width: `${width}px` }}
        className="object-contain"
      />
      {showText && (
        <div>
          <h1 className="text-2xl font-bold">Rock Under Broen</h1>
          <p className="text-sm text-neutral-400">Crew Portal</p>
        </div>
      )}
    </div>
  );
};

export default Logo;
